<template>
  <v-card class="rounded-xl transporter-rental-file" :border="false" :elevation="0">

    <!--ALLER bloc-->
    <div v-if="deliveryAddress">
      <v-col cols="12" class="pt-0">
        <p class="title">
          {{ $t('TRANSPORTER_RENTAL_FILE.TRANSPORTER_GO') }}
        </p>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between py-1 px-0 text grey">
        <p>
          {{ $t('TRANSPORTER_RENTAL_FILE.ADDRESS_NAME') }}
        </p>
        <p> {{ deliveryAddress.address_name || '-' }}</p>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between py-1 px-0 text grey">
        <p>
          {{ $t('TRANSPORTER_RENTAL_FILE.ADDRESS') }}
        </p>
        <p> {{ deliveryAddress.address_number || '-' }} {{ deliveryAddress.address_street || '-' }}</p>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between py-1 px-0 text grey">
        <p>
          {{ $t('TRANSPORTER_RENTAL_FILE.ADDRESS_COMPLEMENT_1') }}
        </p>
        <p> {{ deliveryAddress.address_complement_1 || '-' }}</p>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between py-1 px-0 text grey">
        <p>
          {{ $t('TRANSPORTER_RENTAL_FILE.ADDRESS_COMPLEMENT_2') }}
        </p>
        <p> {{ deliveryAddress.address_complement_2 || '-' }}</p>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between py-1 px-0 text grey">
        <p>
          {{ $t('TRANSPORTER_RENTAL_FILE.CITY') }}
        </p>
        <p> {{ deliveryAddress.address_city || '-' }}</p>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between py-1 px-0 text grey">
        <p>
          {{ $t('TRANSPORTER_RENTAL_FILE.COUNTRY') }}
        </p>
        <p> {{ deliveryAddress.address_country || '-' }}</p>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between py-1 px-0 text grey">
        <p>
          {{ $t('TRANSPORTER_RENTAL_FILE.DESIRED_RECEPTION_DATE') }}
        </p>
        <p> {{ deliveryAddress.desired_reception_date || '-' }}</p>
      </v-col>
      <v-divider class="mt-2 mb-2" />
      <v-col cols="12" class="d-flex justify-space-between py-1 px-0 text grey">
        <p>
          {{ $t('TRANSPORTER_RENTAL_FILE.TRACKING_NUMBER') }}
        </p>
        <p> {{ deliveryAddress.tracking_number || '-' }}</p>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between py-1 px-0 text grey">
        <p>
          {{ $t('TRANSPORTER_RENTAL_FILE.TRANSPORTER_TYPE') }}
        </p>
        <p> {{ deliveryAddress.transporter_type || '-' }}</p>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between py-1 px-0 text grey">
        <p>
          {{ $t('TRANSPORTER_RENTAL_FILE.TRANSPORT_SEND_DATE') }}
        </p>
        <p> {{ deliveryAddress.transport_go_sent_date || '-' }}</p>
      </v-col>
    </div>
  </v-card>
</template>

<script>
import RentalFileService from '@/services/rentalModule/RentalFileService'
import { RentalFileSummary } from '@/models/rentalModule/RentalFileSummary'

export default {
  name: 'TransportInfosRentalFile',
  props: {
    rentalFileSummary: RentalFileSummary
  },
  data() {
    return {
      loading: false,
      deliveryAddress: null,
    }
  },
  created() {
    this.getTransporterInfos()
  },
  watch: {
    rentalFileSummary() {
      this.getTransporterInfos()
    }
  },
  methods: {
    getFormattedDate(date) {
      return new Date(date).toLocaleDateString()
    },
    async getTransporterInfos() {
      this.loading = true
      try {
        this.deliveryAddress = await RentalFileService
          .getRentalFileDeliveryAddress(this.rentalFileSummary.rental_file_technical_id)
      } catch (error) {
        displayToast(this.$t('ERROR_STATUS_CODE_MESSAGE.' + (error.response ? error.response.status : 'UNKNOWN')), 'error')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.transporter-rental-file {
  min-height: 221px;
}

.v-card {
  padding: 20px;
}

.text {
  color: black;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.grey {
  color: #ACACAC;
}

.green {
  color: #559A1B;
}

.black {
  font-weight: 700;
}

.title {
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}
</style>
